const SIDEBAR_WIDTH = 40;

window.timerResizeSidebar = 0;

/**
 * Init Sidebar.
 */
window.initSidebar = function() {
    if ($("body").width() < 768) {
        expandSidebar();
    } else {
        collapseSidebar();
    }
};

/**
 * Expand Sidebar.
 */
window.expandSidebar = function() {
    $(".sidebar").css("width", "");
    $(".sidebar").find("span").show();
    $(".main").css('width', '');
}

/**
 * Collapse Sidebar.
 */
window.collapseSidebar = function() {
    $(".sidebar").css("width", SIDEBAR_WIDTH+"px");
    $(".sidebar").find("span").hide();
    $(".main").css('width', $("body").width() - SIDEBAR_WIDTH);
}

/**
 * Resize Sidebar.
 */
window.resizeSidebar = function() {
    clearTimeout(timerResizeSidebar);
    timerResizeSidebar = setTimeout(function() {
        if ($("body").width() < 768) {
            expandSidebar();
        } else {
            collapseSidebar();
        }
    }, 1000);
}

/**
 * Mouseover, Mouseleave
 */
$('.sidebar')
    .bind('mouseover',function() {
        if ($("body").width() > 768) {
            expandSidebar();
            resizeChosen();
        }
    }).bind('mouseleave', function() {
        if ($("body").width() > 768) {
            collapseSidebar();
            resizeChosen();
        }
    });
